import { useTheme } from '@mui/material';
import { FC } from 'react';
import ReactJson, { ReactJsonViewProps } from 'react-json-view';

type JSONViewerProps = ReactJsonViewProps & {
  title?: string;
};

const JSONViewer: FC<JSONViewerProps> = (props) => {
  //displayArrayKey is available but types are not up to date. Bypass the limitation by injecting it.
  const injectedProps = { ...props, displayArrayKey: false };
  return (
    <ReactJson
      name={props.title ? props.title : null}
      displayDataTypes={false}
      displayObjectSize={false}
      enableClipboard={false}
      theme={useTheme().palette.mode === 'light' ? 'summerfruit:inverted' : 'summerfruit'}
      {...injectedProps}
    />
  );
};

export default JSONViewer;
